
<div class="container main-container">
    <div class="col-lg-12 text-center">
        <h1>Oops!</h1>
        <h2>404 - Not found :(</h2>
        <p>Sorry for that, requested page not found!</p>
        <p><button [routerLink]="['/pages/dashboard']" class="btn btn-primary"><i class="fa fa-home"></i> Take me home</button></p>
    </div>
</div>